import { mapFilterValue } from '../../../utils/tableUtils';

export default function mapCustomFilters({ filter, obj, value }) {
  const mappedValue = mapFilterValue(value);

  switch (filter.column.field) {
    case 'item_id':
      return { ...obj, [filter.column.field]: { eq: mappedValue } };
    default:
      return { ...obj, [filter.column.field]: { match: mappedValue } };
  }
}
